/**
 * Email Service - خالتي هيلة V3
 */

import emailjs from '@emailjs/browser';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const TEMPLATE_NEW_MESSAGE = process.env.REACT_APP_EMAILJS_TEMPLATE_NEW_MESSAGE;
const TEMPLATE_CONTACT_SHARED = process.env.REACT_APP_EMAILJS_TEMPLATE_CONTACT_SHARED;

// Initialize EmailJS
if (PUBLIC_KEY) {
  emailjs.init(PUBLIC_KEY);
}

export const sendNewMessageNotification = async (toEmail, toName, fromName, messagePreview) => {
  if (!SERVICE_ID || !TEMPLATE_NEW_MESSAGE) {
    console.warn('EmailJS not configured');
    return false;
  }

  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_NEW_MESSAGE, {
      to_email: toEmail,
      to_name: toName,
      from_name: fromName,
      message_preview: messagePreview?.substring(0, 50) || 'رسالة جديدة'
    });
    return true;
  } catch (error) {
    console.error('Email send failed:', error);
    return false;
  }
};

export const sendContactSharedNotification = async (toEmail, toName, contactInfo) => {
  if (!SERVICE_ID || !TEMPLATE_CONTACT_SHARED) {
    console.warn('EmailJS not configured');
    return false;
  }

  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_CONTACT_SHARED, {
      to_email: toEmail,
      to_name: toName,
      contact_name: contactInfo.firstName,
      contact_phone: contactInfo.phone || 'لم يُشارك',
      contact_email: contactInfo.email || 'لم يُشارك',
      contact_instagram: contactInfo.instagram || 'لم يُشارك'
    });
    return true;
  } catch (error) {
    console.error('Email send failed:', error);
    return false;
  }
};

export const sendChatEndingReminder = async (toEmail, toName, partnerName, daysLeft) => {
  if (!SERVICE_ID || !TEMPLATE_NEW_MESSAGE) return false;

  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_NEW_MESSAGE, {
      to_email: toEmail,
      to_name: toName,
      from_name: 'خالتي هيلة',
      message_preview: `تذكير: محادثتك مع ${partnerName} تنتهي خلال ${daysLeft} يوم`
    });
    return true;
  } catch (error) {
    console.error('Reminder email failed:', error);
    return false;
  }
};
